import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from "react";
export type ResultMode = "auto" | "json";
export const RESULT_MODE_STORAGE_KEY = "b3os.runHistory.resultMode";
const listeners = new Set<() => void>();
function readMode(): ResultMode {
  if (typeof window === "undefined") return "auto";
  const stored = window.localStorage.getItem(RESULT_MODE_STORAGE_KEY);
  return stored === "json" || stored === "auto" ? stored : "auto";
}
function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  // Cross-tab updates also flow through the storage event.
  const onStorage = (e: StorageEvent) => {
    if (e.key === RESULT_MODE_STORAGE_KEY) listener();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", onStorage);
  };
}
function setStoredMode(mode: ResultMode): void {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(RESULT_MODE_STORAGE_KEY, mode);
  }
  // Notify every hook instance in this tab.
  listeners.forEach(l => l());
}

/** Shared, localStorage-backed Auto/JSON preference for the run-history result viewer. */
export function useAutoViewPreference() {
  const $ = _c(2);
  const mode = useSyncExternalStore(subscribe, readMode, _temp);
  const setMode = _temp2;
  let t0;
  if ($[0] !== mode) {
    t0 = {
      mode,
      setMode
    };
    $[0] = mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp2(next) {
  return setStoredMode(next);
}
function _temp() {
  return "auto" as ResultMode;
}